<template>
<div class="account-index">
  <div class="main-inner">

    <main>
      <div class="decrease_account" v-if="$store.state.corporation.corporation.decreaseFlag">{{nextMonth}}から利用可能アカウント数が減少いたします。{{deadlineDate}}までに、新しいアカウント数の範囲内でアカウント利用者を設定してください。</div>
      <div class="lead">
        <div class="col-20 mt-60">
          <span class="btn-gray2"><button :disabled="$store.state.corporation.corporation.isExpiredCorporation" v-bind:class="[$store.state.corporation.corporation.isExpiredCorporation ? 'btn-disabled' : '']" @click="openNewRegistModal" type="button" name="new-registration">新規ユーザー登録</button></span>
        </div>
        <div class="col-65">
          <div>
            アカウントの利用者をご登録ください。<br>
            管理者がアカウントを利用する場合、管理者の登録も必要になります。<br>
            登録された利用者のメールアドレス宛にパスワード初期設定のお知らせメールを送信します。<br>
            管理者が各アカウントのパスワードを管理したい場合は、「パスワード管理」から新しいパスワードをご登録ください。<br>
            アカウントのユーザーを変更する場合は、下記リンク先の「アカウントのユーザーを変更したいのですが。」をご確認ください。<br>
            <br>
            <a v-bind:href="domain + '/faq#change_account'" class="faq-link" target="_blank">
              アカウントのユーザーを変更したいのですが。 <img class="window-icon-top" src="../../../static/icon-windows.png">
            </a>
          </div>
        </div>
        <div class="col-15 mt-60 text-right">
          <p class="pt-10"><span class="size-l">{{ users.length }} / {{ $store.state.corporation.corporation.guestNumber }}</span> 登録ユーザー</p>
        </div>
      </div>
      <!-- .list-box.row -->
      <section class="list-box white-box row" data-current-order="name:asc">
        <table class="user-data-header">
          <thead>
            <tr>
              <th class="user-email">メールアドレス</th>
              <th class="user-name has-sort-button">氏名
                <i class="icon-sortable">
                  <span v-bind:class="{'order-by current': sort.isAsc}" data-order="name:asc"
                    @click="sortByName(true)">
                  </span>
                  <span v-bind:class="{'order-by current': !sort.isAsc}" data-order="name:desc"
                    @click="sortByName(false)">
                  </span>
                </i>
              </th>
              <th class="user-sex">性別</th>
              <th class="user-department">部署名</th>
              <th class="user-position">役職</th>
              <th class="user-manage">管理</th>
            </tr>
          </thead>
        </table>

        <!-- .item-list -->
        <table class="user-data-list" data-list-name="item-list"
          v-for="user in sortedUsers" v-bind:key="user.id">
          <tbody>
            <tr>
              <td class="user-email">
                <a @click="openEditUser(user)">{{ user.email }} </a>
              </td>
              <td class="user-name">{{ user.name }}</td>
              <td class="user-sex">{{ genderString(user.gender) }}</td>
              <td class="user-department">{{ user.department }}</td>
              <td class="user-position">{{ user.position }}</td>
              <td class="user-manage btn-gray2">
                <button class="user-manage-button" @click="openChangePasswordModal(user)">パスワード管理</button>
                <button @click="openDeleteModal(user)">登録削除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="pager" v-if="this.users.length > 0">
        <ul>
          <li v-if="pager.currentPage > 1"><a @click="setPage(pager.currentPage-1)">&lt;</a></li>
          <template v-if="pager.totalPages <= 5" >
            <li v-for="page in pager.totalPages" v-bind:key="page">
              <a :style="pager.currentPage === page ? {'background-color': '#d1d2d4'} : ''" v-bind:class="[pager.currentPage === page ? 'current' : '']" @click="setPage(page)">{{ page }}</a>
            </li>
          </template>
          <template v-if="pager.totalPages > 5" >
            <template>
              <li>
                <a :style="pager.currentPage === 1 ? {'background-color': '#d1d2d4'} : ''"  @click="setPage(1)">1</a>
              </li>
            </template>
            <template v-if="pager.currentPage > 3">
              <li>…</li>
            </template>
            <template v-if="pager.currentPage > 2">
              <li>
                <a @click="setPage(pager.currentPage-1)">{{ pager.currentPage - 1 }}</a>
              </li>
            </template>
            <template v-if="pager.currentPage > 1 && pager.currentPage < pager.totalPages">
              <li>
                <a style="background-color: #d1d2d4;"  @click="setPage(pager.currentPage)">{{ pager.currentPage }}</a>
              </li>
            </template>
            <template v-if="pager.currentPage < pager.totalPages - 1">
              <li>
                <a @click="setPage(pager.currentPage+1)">{{ pager.currentPage +1 }}</a>
              </li>
            </template>
            <template v-if="pager.currentPage < pager.totalPages - 2">
              <li>…</li>
            </template>
              <li>
                 <a :style="pager.currentPage === pager.totalPages ? {'background-color': '#d1d2d4'} : ''" @click="setPage(pager.totalPages)">{{ pager.totalPages }}</a>
              </li>
            </template>
            <li v-if="pager.currentPage < pager.totalPages" ><a @click="setPage(pager.currentPage+1)">&gt;</a></li>
          </ul>
        </section>
      </main>
      <NewRegistModal @reloadData="reloadData" @close="closeNewRegistModal" v-if="isOpenModal"></NewRegistModal>
      <DeleteUser v-if="isOpenDeleteModal" @reloadData="reloadData" @close="closeDeleteModal" :user="selectedUser"></DeleteUser>
      <ChangeUserPassword v-if="isOpenChangePasswordModal" @close="closeChangePasswordModal" :user="selectedUser"></ChangeUserPassword>
      <AlertModal v-if="isOpenAlertModal" @close="closeAlertModal"></AlertModal>
      <EditUserModal v-if="isOpenEditUserModal" @reloadData="reloadData" @close="closeEditUserModal" :user="selectedUser"></EditUserModal>

  </div>
</div>
</template>

<script>

import NewRegistButton from '@/components/NewRegistButton.vue'
import NewRegistModal from '@/components/NewRegistModal.vue'
import NewsSection from '@/components/NewsSection.vue'
import DeleteUser from '@/components/DeleteUser.vue'
import AlertModal from '@/components/AlertModal.vue'
import EditUserModal from '@/components/EditUser.vue'
import ChangeUserPassword from '@/components/ChangeUserPassword.vue'
import httpResource from '../../http/httpResource'
import store from '../../store/index'
import { getPager } from '../../util/PageService'
import { mapActions } from 'vuex'

export default {
  name: 'AccountIndex',
  components: {
    NewRegistButton,
    NewRegistModal,
    NewsSection,
    DeleteUser,
    ChangeUserPassword,
    AlertModal,
    EditUserModal
  },
  data () {
    return {
      domain: process.env.DOMAIN,
      nextMonth: '',
      deadlineDate: '',
      sort: {
        key: 'name',
        isAsc: true
      },
      users: [],
      isOpenModal: false,
      isOpenDeleteModal: false,
      isOpenChangePasswordModal: false,
      isOpenAlertModal: false,
      isOpenEditUserModal: false,
      selectedUser: {},
      pager: {},
      pagedUsers: []
    }
  },
  computed: {
    sortedUsers () {
      // Dataのリストを書き換えないようにconst化
      const list = this.pagedUsers.slice()

      // ソート開始（ソートの項目変えたければメソッドにKey渡して動的に設定もできるはず）
      list.sort((a, b) => {
        a = a[this.sort.key]
        b = b[this.sort.key]
        return (a === b ? 0 : a > b ? 1 : -1) * (this.sort.isAsc ? 1 : -1)
      })

      return list
    }
  },
  async mounted () {
    let now = new Date()
    let nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    let deadline = new Date(now.getFullYear(), now.getMonth() + 1, 0)
    this.nextMonth = nextMonth.getFullYear() + '年' + (nextMonth.getMonth() + 1) + '月' + nextMonth.getDate() + '日'
    this.deadlineDate = deadline.getFullYear() + '年' + (deadline.getMonth() + 1) + '月' + deadline.getDate() + '日'
    this.reloadCorporationData()
    this.reloadData()
  },
  methods: {
    ...mapActions(['updateCorporation']),
    sortByName: function (isAscClick) {
      // Asc時true、Desc時false
      this.sort.isAsc = isAscClick
    },
    openNewRegistModal () {
      this.isOpenModal = store.getters.getCorporation.guestNumber > this.users.length
      this.isOpenAlertModal = !this.isOpenModal
    },
    openEditUser (user) {
      this.selectedUser = user
      this.isOpenEditUserModal = true
    },
    closeNewRegistModal () {
      this.isOpenModal = false
    },
    openDeleteModal (user) {
      this.selectedUser = user
      this.isOpenDeleteModal = true
    },
    closeDeleteModal () {
      this.isOpenDeleteModal = false
    },
    openChangePasswordModal (user) {
      this.selectedUser = user
      this.isOpenChangePasswordModal = true
    },
    closeChangePasswordModal () {
      this.isOpenChangePasswordModal = false
    },
    closeAlertModal () {
      this.isOpenAlertModal = false
    },
    closeEditUserModal () {
      this.isOpenEditUserModal = false
    },
    async reloadCorporationData () {
      try {
        const response = await httpResource.get('/corporation/info', {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          const data = response.data
          this.updateCorporation(data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async reloadData () {
      try {
        const response = await httpResource.get('/corporation/users', {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          const data = response.data
          this.users = data.users
          this.setPage(1)
        }
      } catch (error) {
        console.log(error)
      }
    },
    genderString (gender) {
      switch (gender) {
        case 0:
          return '男'
        case 1:
          return '女'
        case 2:
          return 'その他'
        default:
          return ''
      }
    },
    setPage (page) {
      this.pager = getPager(this.users.length, page)
      this.pagedUsers = this.users.slice(this.pager.startIndex, this.pager.endIndex + 1)
    }
  }
}
</script>

<style type="text/css">
 a:hover {
  cursor:pointer;
 }
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue